/*
 * @Description:
 * @version:
 * @Date: 2024-01-09 16:45:35
 * @LastEditTime: 2024-01-11 10:03:28
 */
import { defineStore } from 'pinia';
import { router } from '@/router/index.js';
import { localSave, localRead, localRemove } from '@/utils/local-util';
import localStorageKeyConst from '@/constants/local-storage-key-const';

export const useSystemStore = defineStore({
  id: 'system',
  state: () => ({
    sideMenuCollapseFlag: false,
    pageTags: [],
    keepAliveNameList: []
  }),
  getters: {
    getSideMenuCollapse(state) {
      return state.sideMenuCollapseFlag;
    },
    getPageTags(state) {
      return state.pageTags;
    },
    getKeepAliveNameList(state) {
      return state.keepAliveNameList;
    }
  },
  actions: {
    // 设置侧边菜单折叠状态
    setSideMenuCollapse(value) {
      this.sideMenuCollapseFlag = value;
    },

    // 关闭当前页面并跳转
    closePageAndPush(routeName, activeRouteName) {
      const tagIndex = this.pageTags.findIndex((item) => item.name === routeName);
      if (tagIndex === -1) {
        router.push({ name: localStorageKeyConst.HOME_PAGE });
        return;
      }
      const tagItem = this.pageTags[tagIndex];
      this.removePageTag(tagItem);
      if (tagItem.name !== activeRouteName) {
        return;
      }
      if (tagItem.formName) {
        const findForm = this.pageTags.find((tagItem) => tagItem.name === tagItem.formName);
        if (findForm) {
          router.push({ name: findForm.name, query: findForm.query, params: findForm.params });
          return;
        }
      }
      const prevIndex = tagIndex > 0 ? tagIndex - 1 : 0;
      const prevTag = this.pageTags[prevIndex];
      if (prevTag) {
        router.push({ name: prevTag.name, query: prevTag.query, params: prevTag.params });
        return;
      }
      router.push({ name: localStorageKeyConst.HOME_PAGE });
    },

    // 添加tag
    addPageTag(tag) {
      const findItem = this.pageTags.find((item) => item.name === tag.name);
      if (findItem) {
        return;
      }
      this.pageTags.push(tag);
      this.setStorageTags();
    },

    // 删除tag
    removePageTag(tag) {
      const findIndex = this.pageTags.findIndex((item) => item.name === tag.name);
      if (findIndex > -1) {
        this.pageTags.splice(findIndex, 1);
        this.setStorageTags();
        this.removeKeepAliveName(tag.name);
      }
    },

    // 清空tag
    clearPageTag() {
      this.pageTags = [];
      this.setStorageTags();
      this.clearKeepAlive();
    },

    // 设置缓存tag数据
    setStorageTags() {
      localSave(localStorageKeyConst.NAV_TAGS, JSON.stringify(this.pageTags));
    },

    // 获取缓存tag数据
    getStorageTags() {
      const storageTags = localRead(localStorageKeyConst.NAV_TAGS) || null;
      if (storageTags) {
        this.pageTags = JSON.parse(storageTags);
      }
    },

    // 添加KeepAlive
    addKeepAliveName(routeName) {
      // if (this.keepAliveNameList.length >= 30) {
      //   return;
      // }
      const findItem = this.keepAliveNameList.find((item) => item === routeName);
      if (!findItem) {
        this.keepAliveNameList.push(routeName);
      }
    },

    // 删除KeepAlive
    removeKeepAliveName(routeName) {
      this.keepAliveNameList = this.keepAliveNameList.filter((item) => item !== routeName);
    },

    // 清空KeepAlive
    clearKeepAlive() {
      this.keepAliveNameList = [];
    }
  }
});
